import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="px-6 py-10">
      <div className="mx-auto max-w-content space-y-4">
        <p className="font-mono text-xs uppercase tracking-wider text-text-tertiary">
          404
        </p>
        <h1 className="text-2xl font-semibold tracking-tight text-text-primary">
          Seite nicht gefunden
        </h1>
        <Link
          to="/"
          className="text-sm text-text-link underline-offset-4 hover:text-text-link-hover hover:underline"
        >
          Zurück zur Übersicht →
        </Link>
      </div>
    </div>
  );
}
